import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { StoreService } from '../store.service';
import { DEFAULT_TIMEOUT } from './api.service';
import { InvalidDealer, TimeoutError } from './states/store.actions';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {

  private SPECIAL_ROUTES = [
    'decrypt_dealer',
    'encrypt_dealer'
  ];

  constructor(
    private svc: StoreService,
    private store: Store,
    @Inject(DEFAULT_TIMEOUT) protected timeout
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const headersConfig = {};
    const { token } = this.svc.userInfo;

    if (token && token !== undefined && req.url.indexOf('user/verify') == -1) {
      headersConfig['Authorization'] = `bearer ${token}`;
    }

    const request = req.clone({ setHeaders: headersConfig });

    return next.handle(request).pipe(
      timeout(this.timeout),
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 200) {
          if (this.SPECIAL_ROUTES.filter(item => request.url.split('/').includes(item)).length > 0) {
            this.store.dispatch(new InvalidDealer());
          } else {
            if (error.message == 'Timeout has occurred') {
              this.store.dispatch(new TimeoutError());
            } else {
              throw error;
            }
          }
        }
        return EMPTY;
      }),
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body.error && event.body.error == 'invalid_token') {
            this.store.dispatch(new InvalidDealer())
          }
        }
        return event;
      })
    )
  }
}
